import defaultPalette from '../palette';
export default (function (_a) {
    var _b = _a.palette, palette = _b === void 0 ? defaultPalette : _b;
    return {
        MuiTreeItem: {
            root: {
                '&:focus > $content $label, &$selected > $content, &$selected > $content $label, &$selected > $content $label:hover, &$selected:focus > $content $label': {
                    backgroundColor: "" + palette.action.selected,
                },
                '& .MuiTreeItem-content:hover, & .MuiTreeItem-label:hover': {
                    backgroundColor: "" + palette.action.hover,
                },
            },
            label: { color: "" + palette.grey[900] },
            content: {
                height: '1.875rem',
                width: 'inherit',
            },
            group: {
                marginLeft: '0',
            },
            iconContainer: {
                '& svg': {
                    fontSize: '0.8rem',
                },
            },
        },
    };
});
